import { render, staticRenderFns } from "./FormularioAprovacao.vue?vue&type=template&id=0957ea07&"
import script from "./FormularioAprovacao.vue?vue&type=script&lang=js&"
export * from "./FormularioAprovacao.vue?vue&type=script&lang=js&"
import style0 from "./FormularioAprovacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports